export type SignalCalendarDateStyle = 'short' | 'long';

const FORMATTERS: Record<SignalCalendarDateStyle, Intl.DateTimeFormat> = {
  short: new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }),
  long: new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  }),
};

export function formatSignalCalendarDate(
  iso: string | null | undefined,
  style: SignalCalendarDateStyle = 'short',
): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return FORMATTERS[style].format(date);
}
